<script setup>
import CommonGrid from "../../../../frontend/src/components/CommonGrid.vue";
import useGrid from "@/composables/useGrid";
import {onMounted, ref} from "vue";
import marketSectorsService from "@/services/market-sectors.service";
import MarketSectorEdit from "@/components/marketSectors/MarketSectorEdit.vue";

const {items, gridParams, gridMethods} = useGrid(marketSectorsService.getIndexList);

const columns = [
    {
        label: 'ID',
        name: 'id',
        filter: 'text',
    },
    {
        label: 'Name',
        name: 'name',
        filter: 'text',
    },
    {
        label: 'Subsectors',
        name: 'subsectors_count',
        component: 'Link'
    },
    {
        label: 'Partnerships',
        name: 'partnerships_count',
    },
    {
        name: 'actions',
        label: 'Actions',
        component: 'Actions',
    },
];

const edit = ref(null);

onMounted(() => {
    gridMethods.setColumns(columns);
    gridMethods.resetList();
});

function gridAction(params) {
    if (params.action === 'edit') {
        edit.value.open(params.rowId);
    }
}
</script>

<template>
    <div>
        <div class="topbar pl-sm-5">
            <div class="topbar__inner">
                <div class="topbar__key">
                    <header>
                        <button class="button w-100 w-sm-auto" @click="edit.open()">Add Sector</button>
                    </header>
                </div>
            </div>
        </div>

        <div class="main-table-wrapper">
            <div class="main-table overflow-auto">
                <CommonGrid
                    :columns="columns"
                    :items="items"
                    :gridParams="gridParams"
                    :gridMethods="gridMethods"
                    :gridAction="gridAction"
                />
            </div>
        </div>

        <MarketSectorEdit
            ref="edit"
            @saved="gridMethods.updateList"
        />
    </div>
</template>

<style scoped>

</style>
